export default "__VITE_ASSET__2466eaaf__"